import { render, staticRenderFns } from "./PhoneStationViewer.vue?vue&type=template&id=27b9a5ae&scoped=true"
import script from "./PhoneStationViewer.vue?vue&type=script&lang=js"
export * from "./PhoneStationViewer.vue?vue&type=script&lang=js"
import style0 from "./PhoneStationViewer.vue?vue&type=style&index=0&id=27b9a5ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b9a5ae",
  null
  
)

export default component.exports